import LoginAside from '@/assets/loginAsidePic.svg'
import LoginAsideIcon from '@/assets/loginAsideIcon.png'
import '../Login/Login.css';
import ForgotPass from '@/features/user/ForgotPass';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { initUserConfig, resetUserPageStatus, selectInited } from '@/features/user/userSlice';
import { useEffect } from 'react';

function RegisterPage() {
  const inited = useAppSelector(selectInited)
  const dispatch = useAppDispatch()
  
  useEffect(() => {
    if (!inited ) {
      dispatch(initUserConfig())
    }
    dispatch(resetUserPageStatus())
  })
  
  document.title = "Falconchain Check Login"
  
  return (
    <div className="login-container">
      <aside>
        <img className='aside' src={LoginAside} alt="" />
        <img className='aside-icon' src={LoginAsideIcon} alt="" />
      </aside>
      <div className='form-wrap'>
        <ForgotPass />
      </div>
    </div>
  );
}

export default RegisterPage;
